import React from 'react';
import { useSelector } from 'react-redux';

import {
  RESCHEDULE_CLASSES_STAGES,
  rescheduleClassesStageSelector,
} from 'features/classCreation';
import RescheduleClassesView from '../RescheduleClassesView';
import RescheduleConfirmation from '../RescheduleConfirmation';
import RescheduleDetails from '../RescheduleDetails';
import RescheduleValidation from '../RescheduleValidation';

function RescheduleClassesTableStageRenderer() {
  const stage = useSelector(rescheduleClassesStageSelector);

  switch (stage) {
    case RESCHEDULE_CLASSES_STAGES.view:
      return <RescheduleClassesView />;
    case RESCHEDULE_CLASSES_STAGES.details:
      return <RescheduleDetails />;
    case RESCHEDULE_CLASSES_STAGES.confirmation:
      return <RescheduleConfirmation />;
    case RESCHEDULE_CLASSES_STAGES.validation:
      return <RescheduleValidation />;
    default:
      return null;
  }
}

export default RescheduleClassesTableStageRenderer;
